import { request } from './request';
import type { PortalSettingDto } from './types';

/** 官网配置（/portal/userGetPortalSetting，公开接口） */
export function fetchPortalSetting(): Promise<PortalSettingDto> {
  return request('/portal/userGetPortalSetting');
}
